import React from 'react';

const elementList = [
  'abbr',
  'address',
  'article',
  'aside',
  'b',
  'bdi',
  'big',
  'blockquote',
  'body',
  'br',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'dd',
  'del',
  'details',
  'dfn',
  'div',
  'dl',
  'dt',
  'em',
  'figcaption',
  'figure',
  'footer',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'i',
  'ins',
  'kbd',
  'legend',
  'li',
  'main',
  'mark',
  'nav',
  'ol',
  'p',
  'pre',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'section',
  'small',
  'span',
  'strong',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'u',
  'ul',
  'var',
  'wbr',
];

export const htmlElements = elementList.reduce(
  (acc, element) => ({
    ...acc,
    [element]: (chunks: React.ReactNode) => React.createElement(element, null, chunks),
  }),
  {}
);
